import { render, staticRenderFns } from "./chatModal.vue?vue&type=template&id=607c583c&scoped=true&"
import script from "./chatModal.vue?vue&type=script&lang=js&"
export * from "./chatModal.vue?vue&type=script&lang=js&"
import style0 from "./chatModal.vue?vue&type=style&index=0&id=607c583c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607c583c",
  null
  
)

export default component.exports